import { Link } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const headerClass = props.isScrolled ? "primary-header scrolled" : "primary-header";

  return (
    <header id="header" className={headerClass}>
      <div className={"wpo-header-area " + props.hclass}>
        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-2 col-md-3 col-6">
                <div className="navbar-header">
                  <Link
                    onClick={ClickHandler}
                    className="navbar-brand"
                    to="/"
                  >
                    <picture>
                      <source srcSet="/eugene-pereira-logo.avif" type="image/avif" />
                      <img src="/eugene-pereira-logo.png" alt="Doctor Eugene Pereira" style={{maxWidth: 150}} />
                    </picture>
                  </Link>
                </div>
              </div>
              <div className="col-lg-7 col-md-6 d-none d-lg-block">
                <div className="navigation-center">
                  <ul className="nav navbar-nav justify-content-center mb-0">
                    <li>
                      <Link onClick={ClickHandler} to="/">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/about">
                        About
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/blog">
                        Blog
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-6">
                <div className="header-right text-end d-flex justify-content-end align-items-center">
                  <Link
                    onClick={ClickHandler}
                    to="/contact"
                    className="btn-schedule-consultation d-none d-md-inline-block"
                  >
                    <i className="fa fa-phone"></i>
                    Schedule Consultation
                  </Link>
                  <div className="d-lg-none">
                    <MobileMenu />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
